import { Controller } from "@hotwired/stimulus"

// Coordinates the shareholder question section, managing the toggle checkbox
// state based on whether saves are in progress in the collection form.
export default class extends Controller {
  static targets = ["toggleCheckbox"]

  // Listen for save-start and save-complete events from the nested collection-form
  saveStart() {
    if (this.hasToggleCheckboxTarget) {
      this.toggleCheckboxTarget.disabled = true
    }
  }

  saveComplete() {
    if (this.hasToggleCheckboxTarget) {
      this.toggleCheckboxTarget.disabled = false
    }
  }
}
